<template>
    <recycle-scroller :items="items" id="scroller" key-field="key" :item-size="170" v-slot="{ item }">
        <b-container>
            <b-row>
                <b-col class="image-tile" cols="4" v-for="(id, index) in item.ids" :key="String(id)">
                    <img v-if="Array.isArray(id)" class="bound-preview" :src="show_preview_document(id[id.length - 1])"
                        @click="unbind(compute_global_index(item.key, index))" />
                    <b-badge class="badge" v-if="Array.isArray(id)">{{
                            id.length
                    }}</b-badge>
                    <img v-else :class="{
                        preview: true,
                        pre_selected: pre_selected(
                            compute_global_index(item.key, index)
                        ),
                    }" :src="show_preview_document(id)" @mouseover="
    hover(compute_global_index(item.key, index))
" @click="
    bind_item(compute_global_index(item.key, index))
" />

                    <div class="incoherence"
                        v-if="Array.isArray(id) && indexesOfIncoherentBoundDocuments.includes(compute_global_index(item.key, index))">
                        ⚠️
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </recycle-scroller>
</template>
<style scoped>
.badge {
    position: absolute;
    display: block;
    top: 30px;
    left: 10px;
}

.incoherence {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #DC3544;
    margin-top: 20px;
    margin-bottom: 20px;
    width: 106px;
    height: 100%;
    font-size: 20px;
    left: 0;
    pointer-events: none;
}

#scroller {
    height: 70vh;
}

.preview {
    position: absolute;
    height: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
}

.col-4 {
    height: 150px;
}

.bound-preview {
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    margin-top: 20px;
    margin-bottom: 20px;
    height: 100%;
    filter: drop-shadow(3px 3px 3px gray);
}

.image-tile {
    position: relative;
}

.pre_selected {
    filter: sepia(90%);
}

.bound-preview:hover {
    filter: blur(5px);
}

.row {
    height: 150px;
}
</style>
<script>
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import { RecycleScroller } from "vue-virtual-scroller";
export default {
    components: {
        RecycleScroller,
    },
    props: {
        documentIds: Array,
        documentWithReferences: Array,
        paths: Array,
        documentInFullDocs: Array,
        unbind_all: Boolean,
    },
    data: function () {
        return {
            current_index: 0,
            bound: [],
            to_bind: [],
            indexesOfIncoherentBoundDocuments: []
        };
    },
    computed: {
        items: function () {
            let items = this.group_by_3(this.bound.concat(this.to_bind)).map(
                (x, index) => ({ ids: x, key: index })
            );
            return items;
        },
    },
    watch: {
        unbind_all() {
            if (this.unbind_all) {
                this.unbind(this.compute_global_index(0, 0))
                this.$emit("unbound", true)
                this.update_references_for_bound_documents()
            }
        }
    },
    methods: {
        show_preview_document: function (id_from_for_loop) {
            return this.paths.find((e) => e.id == id_from_for_loop)[
                "get_cloudfront_preview_signed_url"
            ];
        },
        update_references_for_bound_documents: function () {
            const references = this.documentWithReferences
            const boundDocumentGroups = this.bound
            const referencesForBoundedDocuments = boundDocumentGroups.map(boundDocumentGroup => {
                return boundDocumentGroup.map(boundDocumentId => {
                    const refObject = references.find(d => d.document_id === boundDocumentId)
                    return refObject ? refObject.document_reference : null
                })
                    .filter(boundDocumentReferences => Boolean(boundDocumentReferences) === true)
            });


            // binding 2 pages/documents on the same full document is potentially incoherent
            // if there are several detected references on each page/document
            const indexesOfIncoherentBoundDocuments = []


            const multipleReferencesOnSameBoundDocument = referencesForBoundedDocuments.map((referencesBoundedDocument, index) => {
                const uniqueReferences = [...new Set(referencesBoundedDocument)]
                if (uniqueReferences.length > 1) {
                    indexesOfIncoherentBoundDocuments.push(index);
                    return uniqueReferences
                }
                return []
            }).filter(incoherence => incoherence.length > 1)

            const numberOfBoundDocumentByReference = referencesForBoundedDocuments.reduce((acc, referencesBoundedDocument) => {
                const uniqueReferences = [...new Set(referencesBoundedDocument)]
                for (let reference of uniqueReferences) {
                    if (acc[reference]) {
                        acc[reference] = acc[reference] + 1
                    } else {
                        acc[reference] = 1
                    }
                }
                return acc
            }, {})
            /* 
                { 
                    'ref123': 1,
                    'refAAA': 2,
                }
            */
            const sameReferenceOnSeveralBoundDocuments = Object
                .entries(numberOfBoundDocumentByReference)
                .filter(([_, value]) => value > 1)
                .map(([key, _]) => key)
            /* 
               ['refAAA']
            */

            for (let duplicatedReference of sameReferenceOnSeveralBoundDocuments) {
                referencesForBoundedDocuments.forEach((refs, index) => {
                    if (refs.includes(duplicatedReference)) {
                        indexesOfIncoherentBoundDocuments.push(index);
                    }
                })
            }

            this.indexesOfIncoherentBoundDocuments = indexesOfIncoherentBoundDocuments;
            this.$emit("updateReferenceIncoherences", {
                multipleReferencesOnSameBoundDocument,
                sameReferenceOnSeveralBoundDocuments
            });
        },
        compute_global_index: function (key, index) {
            return Number(key) * 3 + Number(index);
        },
        group_by_3: function (data) {
            var n = 3;
            var group = [];
            for (var i = 0, j = 0; i < data.length; i++) {
                if (i >= n && i % n === 0) j++;
                group[j] = group[j] || [];
                group[j].push(data[i]);
            }
            return group;
        },
        bind_item: function (global_index) {

            if (this.to_bind.length <= 0) {
                return;
            }
            var index_in_to_bind = global_index - this.bound.length;
            let elements = this.to_bind.splice(0, index_in_to_bind + 1);
            this.bound.push(elements);
            this.update_references_for_bound_documents()
        },
        pre_selected: function (global_index) {
            return global_index - this.bound.length <= this.current_index;
        },
        hover: function (global_index) {
            this.current_index = global_index - this.bound.length;
            this.$emit("tile", this.to_bind[this.current_index]);
        },
        unbind: function (global_index) {
            let initial_index = this.bound.length - 1;
            for (var i = initial_index; i >= global_index; i--) {
                let ids = this.bound.splice(i, i + 1)[0];
                this.to_bind = ids.concat(this.to_bind);
                this.$forceUpdate();
            }
            this.update_references_for_bound_documents()
        },
        bind_all_from_full_documents: function () {
            if (this.documentInFullDocs.length > 0) {
                this.bound = this.documentInFullDocs
                this.to_bind = []
                this.update_references_for_bound_documents()
            }
        }
    },
    mounted: function () {
        this.to_bind = JSON.parse(JSON.stringify(this.documentIds));
        this.hover(0);
        this.bind_all_from_full_documents()

        window.addEventListener("keydown", (event) => {
            if (event.key == "ArrowRight") {
                event.preventDefault();
                this.current_index++;
                this.current_index = Math.min(
                    this.to_bind.length - 1,
                    this.current_index
                );
                this.hover(this.bound.length + this.current_index);
            } else if (event.key == "ArrowLeft") {
                this.current_index--;
                this.current_index = Math.max(0, this.current_index);
                this.hover(this.bound.length + this.current_index);
            } else if (event.key == "Enter") {
                this.bind_item(this.bound.length + this.current_index);
                this.current_index = 0;
                this.hover(this.bound.length);
            }
        });
    },
};
</script>
